module.exports = __webpack_public_path__ + "static/media/attach.b82faf73.svg";